export default __webpack_public_path__ + "static/media/img5.48745280.jpg";